import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Crown, X } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const DISMISS_KEY = 'go_pro_banner_dismissed';

// Upsell strip for logged-in Free users. Dismissal lasts for the browser session.
export const GoProBanner = () => {
  const { isAuthenticated, isPro, loading } = useAuth();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === '1');
  if (loading || !isAuthenticated || isPro || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="bg-[#00247D] text-white border-b border-amber-400/40 print:hidden" data-testid="go-pro-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <Crown className="hidden sm:block w-5 h-5 text-amber-300 shrink-0" />
        <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
          <p className="text-xs sm:text-sm leading-snug text-white/90" data-testid="go-pro-banner-text">
            Want to edit your schedule, add team logos and rosters, player and team photos, add manual games,
            display player and team stats and more? <span className="font-bold text-amber-300">Go Pro!</span>
          </p>
          <Link
            to="/pricing"
            className="self-start sm:self-auto shrink-0 inline-flex items-center gap-1.5 rounded-full bg-amber-400 hover:bg-amber-300 text-[#00247D] text-xs sm:text-sm font-bold px-4 py-1.5 transition-colors"
            data-testid="go-pro-banner-upgrade-btn"
          >
            <Crown className="w-3.5 h-3.5" /> Upgrade
          </Link>
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="self-start sm:self-center shrink-0 p-1 rounded text-white/60 hover:text-white hover:bg-white/10 transition-colors"
          aria-label="Dismiss"
          data-testid="go-pro-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default GoProBanner;
